// extracted by mini-css-extract-plugin
export var growableInput = "_36-0";
export var tagContainer = "_36-2";
export var textInput = "_36-1";